export const DELETE_OPERATOR_NODE_REQUEST = "DELETE_OPERATOR_NODE_REQUEST";
export const DELETE_OPERATOR_NODE_SUCCESS = "DELETE_OPERATOR_NODE_SUCCESS";
export const DELETE_OPERATOR_NODE_FAILURE = "DELETE_OPERATOR_NODE_FAILURE";
